<template>
    <div>
        <div
            id="header"
            class="header navbar-default"
            v-bind:style="headerSidebarOffsetStyle"
        >
            <div class="navbar-header">
                <!-- 모바일에서는 RightSideBar가 나타나지 않도록 한다. -->
                <button
                    class="navbar-toggle pull-right"
                    v-on:click="toggleMobileRightSidebar"
                    v-if="pageOptions.pageWithTwoSidebar && pageOptions.pageMobileRightSidebarToggled"
                >
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <button
                    class="navbar-toggle pull-left"
                    v-on:click="toggleMobileSidebar"
                    v-if="pageOptions.pageWithTwoSidebar"
                >
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <router-link to="/" class="navbar-brand">
                    <!-- <img v-bind:src="masterLogo" style="width:27px;height:20px;margin-right:7px;" /> -->
                    <!-- <span class="navbar-logo"></span> -->
                    <!-- <b>{{ master.brand }}</b> -->
                    <img :src="masterLogo" @error="onLogoError" />
                </router-link>
                <button
                    class="navbar-toggle"
                    v-on:click="toggleMobileSidebar"
                    v-if="
                        !pageOptions.pageWithTwoSidebar &&
                        !pageOptions.pageWithTopMenu &&
                        !pageOptions.pageWithoutSidebar
                    "
                >
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <button
                    class="navbar-toggle"
                    v-on:click="toggleMobileTopMenu"
                    v-if="pageOptions.pageWithTopMenu && pageOptions.pageWithoutSidebar"
                >
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
            </div>

            <!-- 메가 메뉴 -->
            <header-mega-menu v-if="pageOptions.pageWithMegaMenu && pageOptions.pageDualMenu"></header-mega-menu>

            <!-- 헤더 버튼 -->
            <ul class="navbar-nav navbar-right">
                <!-- 조회 -->
                <li
                    class="navbar-form"
                    v-if="pageOptions.pageWithSearchBar"
                    v-bind:class="{ 'hidden-sm': pageOptions.pageWithMegaMenu }"
                >
                    <form name="search_form" v-on:submit="searchForm">
                        <div class="form-group">
                            <input
                                type="text"
                                class="form-control"
                                :placeholder="$t('키워드를 입력하세요.')"
                                v-model="searchText"
                            />
                            <button type="submit" class="btn btn-search">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </form>
                </li>

                <!-- Dark Mode Test -->
                <!-- <li v-xe-pm.E>
          <xe-checkbox
            v-model="pageOptions.pageContentInverseMode"
            label="Dark"
            tooltip="Dark Mode"
            @change="onChangeInverseMode"
          />
        </li> -->
                <li v-if="isLoading" class="nav-loading-spinner">
                    <ThreeDotsSpinner size="small" />
                </li>

                <!-- 시계 -->
                <li v-show="!isMobile && isWscConnected">
                    <clock-top @change-alarm="onChangeAlarms" />
                </li>
                <li v-if="!isWscConnected">
                    <a href="javascript:;" v-b-tooltip.hover :title="$t('서버와의 연결이 끊어졌습니다.')">
                        <i class="fa fa-unlink" />
                    </a>
                </li>

                <!-- 기상 -->
                <!-- <li class="dropdown">
          <weather-top />
        </li> -->
                <!-- 인증서 다운로드 -->
                <li v-b-tooltip.hover title="인증서 다운로드">
                    <a href="javascript:;" v-on:click="downloadCert">
                        <i class="fas fa-shield-alt" style="cursor: pointer; font-size: 1.2rem" />
                    </a>
                </li>
                <!-- 알람 -->
                <li
                    class="d-flex align-items-center"
                    style="cursor: pointer; font-size: 1.2rem; padding: 10px 10px 10px 10px"
                    v-b-tooltip.hover
                    title="환산계수 조회"
                    @click="showConversionModal"
                >
                    <i class="fas fa-retweet"> </i>
                </li>
                <li
                    class="d-flex align-items-center"
                    v-b-toggle.sidebar-1
                    v-b-tooltip.hover
                    title="관제점 조회"
                    @click="showSideBar"
                    style="cursor: pointer; font-size: 1.2rem; padding: 10px 10px 10px 10px"
                >
                    <!-- <button v-b-toggle.sidebar-1 type="button" class="btn btn-primary" @click="showSideBar">관제점 조회</button> -->
                    <i class="fas fa-th-list"></i>
                </li>
                <!-- 메뉴얼 다운로드 -->
                <b-nav-item-dropdown toggle-class="f-s-14" no-caret menu-class="media-list dropdown-menu-right">
                    <template slot="button-content">
                        <b-tooltip target="download-icon" placement="bottom" :offset="10"> 메뉴얼 다운로드 </b-tooltip>

                        <i id="download-icon" class="fa fa-download" style="cursor: pointer; font-size: 1.2rem"></i>
                    </template>
                    <b-dropdown-header>{{ "메뉴얼 다운로드" }}</b-dropdown-header>
                    <div class="alarm-container">
                        <b-dropdown-item class="media p-t-5 p-b-5" @click="openUserManual">
                            {{ "사용자 메뉴얼 다운로드" }}
                        </b-dropdown-item>
                        <!-- GS 테스트를 위한 임시 작업, 20250612 -->
                        <!-- <b-dropdown-item class="media p-t-5 p-b-5" :href="adminManualPath" download>
                            {{ "관리자 메뉴얼 다운로드" }}
                        </b-dropdown-item>
                        <b-dropdown-item class="media p-t-5 p-b-5" :href="engineerManualPath" download>
                            {{ "엔지니어 메뉴얼 다운로드" }}
                        </b-dropdown-item> -->
                    </div>
                </b-nav-item-dropdown>
                <alarm-top :isChangeAlarm="isChangeAlarm" class="alarmTop" />
                <!-- 언어 : 20210217 다국어 숨김 -->
                <!-- 다국어 일시 활성화 -->
                <!-- <locale-top /> -->
                <!-- 프로필 -->
                <user-top />

                <!-- 오른쪽 사이드바 토글 버튼 -->
                <li class="divider d-none d-md-block" v-if="pageOptions.pageWithTwoSidebar"></li>
                <li class="d-none d-md-block" v-if="pageOptions.pageWithTwoSidebar">
                    <!-- toggleRightSidebar -->
                    <a href="javascript:;" v-on:click="toggleRightSidebarCollapsed" class="f-s-14">
                        <i class="fa fa-th"></i>
                    </a>
                </li>
            </ul>
            <b-sidebar
                ref="PointSideBar"
                id="sidebar-1"
                bg-variant="white"
                backdrop-variant="secondary"
                width="45vw"
                @hidden="closeSidebar"
                no-header
                shadow
                right
                backdrop
            >
                <div v-if="sideBar" style="padding: 1rem; height: 100%">
                    <SearchComponent :type="'global'" @close="closeSidebar" />
                </div>
            </b-sidebar>
        </div>

        <b-modal id="conversion-modal-header" ref="conversionModal" title="환산계수 조회" size="lg" hide-footer>
            <table class="table text-center table-striped table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th class="convertModalHeader">에너지 종류</th>
                        <th class="convertModalHeader">현재 단위</th>
                        <th class="convertModalHeader">변환 대상</th>
                        <th class="convertModalHeader">계수 (base)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(conversion, index) in flatConversionFactors" :key="index" class="convertModalBody">
                        <td
                            class="bodyTd align-middle table-white"
                            v-if="conversion._rowspan"
                            :rowspan="conversion._rowspan"
                        >
                            {{ convertTypeLabel(conversion.energyType) }}
                        </td>
                        <td class="bodyTd">{{ conversion.unit }}</td>
                        <td class="bodyTd">{{ conversion.to }}</td>
                        <td class="bodyTd">{{ conversion.base }}</td>
                    </tr>
                </tbody>
            </table>
        </b-modal>
    </div>
</template>

<script>
//import PageOptions from "../.. /config/PageOptions.vue";
import HeaderMegaMenu from "./HeaderMegaMenu.vue";

import ClockTop from "./ClockTop.vue";
// import WeatherTop from "./WeatherTop.vue";
import AlarmTop from "./AlarmTop.vue";
// import LocaleTop from "./LocaleTop.vue";
import UserTop from "./UserTop.vue";
import SearchComponent from "@src/views/component/v2.1/PointSearch/Search.vue";
import ThreeDotsSpinner from "@src/components/spinner/ThreeDotsSpinner.vue";
import xelib from "xelib";
import { mapState } from "vuex";
import backEndApi from "@src/api/backEndApi";
import config from "@libs/config.js";
import { extractFilenameFromResponse } from "@src/utils/exportExcelTitle.js";

const { Unit } = xelib.PointBoxV2;
export default {
    name: "Header",
    components: {
        HeaderMegaMenu,
        ClockTop,
        // WeatherTop,
        AlarmTop,
        // LocaleTop,
        UserTop,
        SearchComponent,
        ThreeDotsSpinner,
    },
    data() {
        return {
            //pageOptions: PageOptions,
            searchText: "",
            isChangeAlarm: false,
            // logo: require("/public/assets/xems/common/logo/kgct-log.png"), // masterLogo computed 사용으로 제거

            timeout: null,
            timer: { stopped: true, time: 0 },
            sideBar: false,
            conversionFactors: {},
            userManualPath: `${config.backend.apiUrl}/resource/manual/CxEMS-v2.2-사용자메뉴얼.pdf`,
            defaultLogo: require("/public/assets/xems/common/logo/kgct-log.png"),
            logoLoadFailed: false,
        };
    },
    computed: {
        ...mapState({
            unitTypes: (state) => state.unitTypes,
            isLoading: (state) => state.isLoading,
        }),
        flatConversionFactors() {
            const result = [];
            for (const energyType in this.conversionFactors) {
                const items = this.conversionFactors[energyType];
                const entries = Object.values(items).map((item) => ({
                    energyType,
                    ...item,
                }));

                // 첫 항목에만 rowspan 정보 추가
                if (entries.length > 0) {
                    entries[0]._rowspan = entries.length;
                }

                result.push(...entries);
            }
            return result;
        },
        master() {
            return this.$store.getters.master;
        },
        masterLogo() {
            const customLogo = this.master?.logo;
            if (!customLogo || this.logoLoadFailed) {
                return this.defaultLogo;
            }
            return customLogo;
        },
        labelTheme() {
            // 사용자 지정 우선
            return localStorage.labelTheme || this.master.labelTheme || "blue";
        },
        isWscConnected() {
            return this.$store.getters.isWscConnected;
        },
        weather() {
            return this.$store.getters.weather;
        },
        isEditMode() {
            return this.$store.getters.isEditMode;
        },
        /**
         * PC에서만 모바일 사이드바 토글 시 헤더를 민다.
         * 좁은 화면(<1200)은 오버레이이므로 인라인 margin을 넣지 않는다.
         */
        headerSidebarOffsetStyle() {
            if (typeof window !== "undefined" && window.innerWidth < 1200) {
                return {};
            }
            if (this.pageOptions.pageMobileSidebarToggled) {
                return { marginLeft: "220px" };
            }
            return {};
        },
    },
    watch: {
        "master.logo"() {
            this.logoLoadFailed = false;
        },
        // "pageOptions.pageContentInverseMode"() {
        //   // PageOptions.pageContentInverseMode = this.pageOptions.pageContentInverseMode;
        //   console.log("Header Watch", this.pageOptions.pageContentInverseMode ? "Inverse" : "Normal");
        // },
    },
    mounted() {
        this.$store.dispatch("UPDATE_WEATHER");
        this.conversionFactors = Unit.getConversionFactors();
    },
    methods: {
        onLogoError() {
            this.logoLoadFailed = true;
        },
        async downloadCert() {
            try {
                let result = await backEndApi.cert.getCert();
                if (result.status === 200 && result.data) {
                    // Blob 데이터를 파일로 다운로드
                    const blob = new Blob([result.data], {
                        type: "application/x-x509-ca-cert",
                    });

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;

                    // 서버에서 제공하는 파일명 추출 (없으면 기본값 사용)
                    const fileName = extractFilenameFromResponse(result, "xems-kbet RootCA.crt");
                    link.download = fileName;

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    window.URL.revokeObjectURL(url);
                    this.alertNoti("RootCa 인증서 다운로드가 완료되었습니다.");
                } else {
                    this.alertWarning(result.data?.message || "인증서 다운로드에 실패했습니다.");
                }
            } catch (error) {
                console.error(error);
                this.alertWarning(error.message || "인증서 다운로드 중 오류가 발생했습니다.");
            }
        },
        async getMenual(type) {
            let result;
            try {
                if (type == "user") {
                    result = await backEndApi.file.userManual();
                } else if (type == "admin") {
                    result = await backEndApi.file.adminManual();
                } else if (type == "engineer") {
                    result = await await backEndApi.file.engineerManual();
                } else return;

                if (result.status !== 200) this.alertWarning(`${result.data.message}`);
            } catch (e) {
                console.error(e);
            }
        },
        convertTypeLabel(type) {
            return this.unitTypes?.find((item) => item.value === type).text;
        },
        showConversionModal() {
            this.$refs.conversionModal.show();
        },
        showSideBar() {
            this.sideBar = true;
        },
        closeSidebar() {
            this.$refs.PointSideBar.hide();
            console.log("adsfasdfasdf");
            this.sideBar = false;
        },
        toggleMobileSidebar() {
            this.pageOptions.pageMobileSidebarToggled = !this.pageOptions.pageMobileSidebarToggled;
        },
        toggleMobileRightSidebar() {
            this.pageOptions.pageMobileRightSidebarToggled = !this.pageOptions.pageMobileRightSidebarToggled;
        },
        toggleMobileTopMenu() {
            this.pageOptions.pageMobileTopMenu = !this.pageOptions.pageMobileTopMenu;
        },
        toggleMobileMegaMenu() {
            this.pageOptions.pageMobileMegaMenu = !this.pageOptions.pageMobileMegaMenu;
        },
        toggleRightSidebar() {
            this.pageOptions.pageRightSidebarToggled = !this.pageOptions.pageRightSidebarToggled;
        },
        toggleRightSidebarCollapsed() {
            this.pageOptions.pageRightSidebarCollapsed = !this.pageOptions.pageRightSidebarCollapsed;
        },
        searchForm: function (e) {
            e.preventDefault();
            this.$router.push({
                name: "search",
                params: { searchText: this.searchText },
            });
        },
        openWeatherDetail() {
            this.$router.push(`/operation/weather`);
        },
        onChangeAlarms() {
            this.isChangeAlarm = !this.isChangeAlarm;
        },
        onChangeInverseMode(checked) {
            this.pageOptions.pageContentInverseMode = checked;
        },
        openUserManual() {
            window.open(this.userManualPath, "_blank");
        },
    },
};
</script>
<style scoped>
.nav-loading-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 22px;
    /* width: 0.5rem; */
    /* height: 1rem; */
}

.convertModalHeader {
    /* font-size: 15px; */
    padding-left: 1rem;
    font-weight: 800;
}

.convertModalBody {
    /* font-size: 12px; */
    font-weight: bold;
}

.bodyTd {
    /* padding: 1rem 0.7rem; */
}

.alarmTop {
    /* margin-right: 7px; */
}
</style>
